import { z } from 'zod'

export const assignBenefitsAssignBenefitsRequestSchema = z.object({
  /** 禮遇商品id */
  commodityId: z.string(),
  /** 使用起始時間 */
  useStartTime: z.string(),
  /** 使用截止時間 */
  useEndTime: z.string(),
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** BizCode */
  bizId: z.string(),
  /** 數量 */
  quantity: z.number()
})

export interface AssignBenefitsAssignBenefitsRequest
  extends z.infer<typeof assignBenefitsAssignBenefitsRequestSchema> {}

export class AssignBenefitsAssignBenefitsRequest {
  constructor() {
    return {
      commodityId: '',
      useStartTime: '',
      useEndTime: '',
      memberCardNumber: '',
      bizId: '',
      quantity: 0
    }
  }
}
